angular.module('offlineChecker')
  .controller('Base',Base);

Base.$inject = ['uiManagerFactory','sessionFactory'];

function Base(uiManagerFactory, sessionFactory){
  var vm = this;
  vm.uiManager = uiManagerFactory;
  vm.session = sessionFactory;
}
